import type { DataRequestStatus } from '@api-client/api'
import { useTranslation } from 'react-i18next'

import { StatusChip, type StatusIntent } from './StatusChip'

// Intent axis: warning = action needed from me, info = waiting on the other party,
// danger = terminal negative, success = terminal positive, neutral = inactive.
const CUSTOMER_INTENT: Record<DataRequestStatus, StatusIntent> = {
	NOT_STARTED: 'neutral',
	REQUESTED: 'info',
	REQUESTED_CLARIFICATION: 'info',
	PENDING_REVIEW: 'warning',
	COMPLETED: 'success',
	REJECTED: 'danger',
	DECLINED: 'danger',
	CANCELED: 'neutral',
}

const SUPPLIER_INTENT: Record<DataRequestStatus, StatusIntent> = {
	NOT_STARTED: 'neutral',
	REQUESTED: 'warning',
	REQUESTED_CLARIFICATION: 'warning',
	PENDING_REVIEW: 'info',
	COMPLETED: 'success',
	REJECTED: 'danger',
	DECLINED: 'danger',
	CANCELED: 'neutral',
}

const productRequestStatusToIntent = (
	status: DataRequestStatus,
	isCustomer: boolean
): StatusIntent =>
	isCustomer ? CUSTOMER_INTENT[status] : SUPPLIER_INTENT[status]

interface Props {
	status: DataRequestStatus
	isCustomer: boolean
	onClick?: () => void
}

const ProductStatusChip: React.FC<Props> = ({
	status,
	isCustomer,
	onClick,
}) => {
	const { t } = useTranslation()
	const label = isCustomer
		? t('request.asCustomer.status', { context: status })
		: t('request.asSupplier.status', { context: status })
	return (
		<StatusChip
			intent={productRequestStatusToIntent(status, isCustomer)}
			label={label}
			onClick={onClick}
		/>
	)
}

export { productRequestStatusToIntent, ProductStatusChip }
